import React, { Component } from "react";
import PropTypes from "prop-types";
import SignupForm from "../../components/SignupForm";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions } from "../../modules/auth";
import { Link } from "react-router-dom";

const propTypes = {
  signup: PropTypes.func.isRequired,
  authenticating: PropTypes.bool.isRequired,
  failAuth: PropTypes.string
};

class Signup extends Component {
  onSubmit = async values => {
    const {
      signup,
      history: { push }
    } = this.props;
    const { response } = await signup(values);
    if (response) {
      push("/dealers/new");
    }
  };

  render() {
    const { authenticating, failAuth } = this.props;
    return (
      <div>
        <SignupForm
          authenticating={authenticating}
          failAuth={failAuth}
          onSubmit={this.onSubmit}
        />
        <div style={{ marginTop: 10, marginBottom: 10, textAlign: "center" }}>
          <Link to="/">I already have an account.</Link>
        </div>
        <div style={{ marginTop: 10, marginBottom: 10, textAlign: "center" }}>
          <Link to="/reset_password">Forgot your password?</Link>
        </div>
      </div>
    );
  }
}

Signup.propTypes = propTypes;

const mapStateToProps = state => ({ ...(state.auth || {}) });
const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(actions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Signup);
